import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/cloud-users/:userId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    membershipId: string;
    userId: string;
}
const mutationFn = ({ membershipId, parkingId, userId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { membershipId, parkingId, userId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteMembershipCloudUser };
